import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartBar, faSearch, faFileAlt, faSignOutAlt, faUsers, faCar, faList } from '@fortawesome/free-solid-svg-icons';
import './PanelLayout.css';

const PanelLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/panel/login');
  };

  return (
    <div className="panel-layout">
      <aside className="panel-sidebar">
        <div className="sidebar-header">
          <h2>Panel Admin</h2>
        </div>
        <nav className="sidebar-nav">
          <NavLink to="/panel" end className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faChartBar} className="nav-icon" />
            Dashboard
          </NavLink>
          <NavLink to="/panel/consultas" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faSearch} className="nav-icon" />
            Consultas
          </NavLink>
          <NavLink to="/panel/logs" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faFileAlt} className="nav-icon" />
            Logs
          </NavLink>
          <NavLink to="/panel/clientes" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faUsers} className="nav-icon" />
            Clientes API
          </NavLink>
          <NavLink to="/panel/consulta-multas" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faCar} className="nav-icon" />
            Consulta Multas
          </NavLink>
          <NavLink to="/panel/consultas-api" className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>
            <FontAwesomeIcon icon={faList} className="nav-icon" />
            Consultas API
          </NavLink>
        </nav>
      </aside>
      <div className="panel-main">
        <header className="panel-header">
          <div className="header-title">
            Sistema de Multas - Administración
          </div>
          <div className="header-user">
            <span className="user-name">{user?.nombre_completo || user?.username}</span>
            <button className="logout-btn" onClick={handleLogout}>
              <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar Sesión
            </button>
          </div>
        </header>
        <main className="panel-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default PanelLayout;
